<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDisplay } from 'vuetify'

const props = defineProps<{
  isOpen?: boolean
  selected?: number
}>()

const emits = defineEmits(['close'])
const { t } = useI18n()
const { mobile } = useDisplay()
const isMobile = computed(() => mobile.value)
const internalIsOpen = ref(props.isOpen ?? true)

watch(internalIsOpen, (val) => {
  if (!val) emits('close')
})
</script>

<template>
  <v-card
    id="mass-actions-dialog"
    v-model="internalIsOpen"
    variant="flat"
    class="d-flex align-center flex-wrap px-4 py-2"
    style="
      width: 100%;
      background-color: white;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      margin-top: 15px;
    "
    :style="{ gap: isMobile ? '16px' : '24px' }"
    @close="$emit('close')"
  >
    <template #title>
      <div v-if="isMobile" class="d-flex w-100 justify-space-between flex-row">
        <p class="text-caption font-weight-bold">
          {{ t('events.massActions') }}
        </p>
        <p class="text-caption font-weight-medium">
          {{ t('events.selected', { number: props.selected }) }}
        </p>
      </div>
      <p v-else class="text-caption font-weight-medium">
        {{ t('events.selected', { number: props.selected }) }}
      </p>
    </template>
    <v-divider
      v-if="isMobile"
      :thickness="1"
      class="mx-n4 mb-0 border-opacity-100"
    />

    <slot />
  </v-card>
</template>

<style>
@media (max-width: 960px) {
  .v-card-item {
    width: 100% !important;
    padding: 0 !important;
    padding-top: 8px !important;
  }
}
</style>
